<!--
 * @Description: 常规工作/日常事务 申请操作
 * @Author: peifu
 * @Date: 2022-12-06 22:04:49
 * @LastEditors: PF
 * @LastEditTime: 2023-08-11 09:57:59
-->

<template>
  <div>
    <el-dialog class="w900 h600" :model-value="isShenQingBianJiHome" :before-close="handleClose" :close-on-click-modal="false" destroy-on-close>
      <template #header>
        <div class="tou_bu">
          <el-tabs v-model="activeName">
            <el-tab-pane label="发起审批" :name="1"></el-tab-pane>
            <el-tab-pane label="查看数据" :name="2"></el-tab-pane>
          </el-tabs>
          <div class="but_group">
            <!-- <el-button class="but" @click="caoGaoClick()"><el-icon class="el-icon--left"><Files /></el-icon>草稿箱</el-button> -->
          </div>
        </div>
      </template>
      <!-- 发起审批 -->
        <el-card v-if="activeName === 1" shadow="never">
          <h2>{{ sqczObj.bdmc }}</h2>
          <el-divider border-style="dashed" />
          <!-- 类型：[1]单行文本 [2]多行文本 [3]数字 [4]下拉框 [5]单选 [6]多选 [7]日期 [8]日期区间 [99]标签 -->
          <el-form ref="formRef" :model="dynamicValidateForm" label-width="180px" >
            <el-row v-for="(domain, index) in dynamicValidateForm.domains" :key="index">
              <el-col :span="24" v-if="domain.lx === 1">
                <el-form-item :label="domain.bt" :prop="'domains.' + index + '.inputVal'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
                  <el-input v-model="domain.inputVal" :placeholder="domain.tswz" :maxlength="domain.zdcd || ''" show-word-limit />
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="domain.lx === 2">
                <el-form-item :label="domain.bt" :prop="'domains.' + index + '.inputVal'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
                  <el-input type="textarea" v-model="domain.inputVal" :placeholder="domain.tswz" :rows="domain.mrhs"  :maxlength="domain.zdcd || ''" show-word-limit resize="none" />
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="domain.lx === 3">
                <el-form-item :label="domain.bt" :prop="'domains.' + index + '.inputVal'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
                  <div class="shu_zi_kuang" :class="!domain.qz && !domain.hz ? 'wu_zhui' : !domain.qz ? 'wu_qian_zhui' : !domain.hz ? 'wu_hou_zhui' : 'you_zhui'">
                    <div class="qian_zhui" v-if="domain.qz">{{domain.qz}}</div>
                    <el-input-number v-if="!domain.zdz && !domain.zxz && !domain.xsjd" v-model="domain.inputVal"></el-input-number>
                    <el-input-number v-if="domain.zdz && !domain.zxz && !domain.xsjd" v-model="domain.inputVal" :max="domain.zdz"></el-input-number>
                    <el-input-number v-if="!domain.zdz && domain.zxz && !domain.xsjd" v-model="domain.inputVal" :min="domain.zxz"></el-input-number>
                    <el-input-number v-if="!domain.zdz && !domain.zxz && domain.xsjd" v-model="domain.inputVal" :precision="domain.xsjd"></el-input-number>
                    <el-input-number v-if="domain.zdz && domain.zxz && !domain.xsjd" v-model="domain.inputVal" :max="domain.zdz" :min="domain.zxz"></el-input-number>
                    <el-input-number v-if="!domain.zdz && domain.zxz && domain.xsjd" v-model="domain.inputVal" :min="domain.zxz" :precision="domain.xsjd"></el-input-number>
                    <el-input-number v-if="domain.zdz && domain.zxz && domain.xsjd" v-model="domain.inputVal" :max="domain.zdz" :min="domain.zxz" :precision="domain.xsjd"></el-input-number>
                    <div class="hou_zhui" v-if="domain.hz">{{domain.hz}}</div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="domain.lx === 4">
                <el-form-item :label="domain.bt" :prop="'domains.' + index + '.inputVal'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
                  <el-select v-model="domain.inputVal" :placeholder="domain.tswz">
                    <el-option v-for="item in domain.xxs" :key="item.id" :label="item.xxwb" :value="item.id" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="domain.lx === 5">
                <el-form-item :label="domain.bt" :prop="'domains.' + index + '.inputVal'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
                  <el-radio-group v-model="domain.inputVal" :placeholder="domain.tswz">
                    <el-radio v-for="(item,index) in domain.xxs" :key="index" :label="item.id">{{ item.xxwb }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="domain.lx === 6">
                <el-form-item :label="domain.bt" :prop="'domains.' + index + '.inputArr'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
                  <el-checkbox-group v-model="domain.inputArr" :placeholder="domain.tswz">
                    <el-checkbox v-for="item in domain.xxs" :key="item.id" :label="item.id">{{ item.xxwb }}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="domain.lx === 7">
                <el-form-item :id="'riqi'+ index" :label="domain.bt" :prop="'domains.' + index + '.inputVal'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
                  <input class="el-input ri_qi_kuang" v-if="domain.rqlx === 1" :value="domain.inputVal" type="date" :min="domain.zxz" :max="domain.zdz">
                  <input class="el-input ri_qi_kuang" v-if="domain.rqlx === 2" :value="domain.inputVal" type="datetime-local" :min="domain.zxz" :max="domain.zdz">
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="domain.lx === 8">
                <el-form-item :label="domain.bt" :prop="'domains.' + index + '.inputArr'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
                  <el-date-picker v-model="domain.inputArr" :type="domain.rqlx === 1 ? 'daterange' : 'datetimerange'" :format="domain.rqlx === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'" :value-format="domain.rqlx === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'" :placeholder="domain.tswz" range-separator="-" :start-placeholder="domain.tswz" :end-placeholder="domain.bt2" />
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="domain.lx === 99">
                <el-form-item>
                  <div :class=" domain.dqfs === 2 ? 'dui_qi_center' : domain.dqfs === 3 ? 'dui_qi_right' : domain.dqfs === 4 ? 'dui_qi_justify' : 'dui_qi_left'" :style="'width: 100%;color: ' + domain.ztys+';font-size: ' + domain.ztdx + 'px;'">
                    {{ domain.smwz }}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      <!-- 查看数据 -->
        <el-card v-if="activeName === 2" class="cha_kan_shu_ju" shadow="never">
          <el-container>
            <el-header> </el-header>
            <el-main>
              <el-table :data="tableData" border v-loading="loading" height="100%">
                <el-table-column type="index" label="序号" align="center" width="80" />
                <el-table-column prop="sqrxm" label="申请人姓名" align="center" show-overflow-tooltip />
                <el-table-column prop="sqrjgmc" label="申请人机构名称" align="center" show-overflow-tooltip />
                <el-table-column prop="sqsj" label="申请时间" align="center" show-overflow-tooltip />
                <el-table-column prop="sqzt" label="申请状态" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <span v-for="(item, index) in clztData.list" :key="index">
                      <span v-if="scope.row.sqzt === item.value">{{item.name}}</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="dqjd" label="当前进度" align="center" show-overflow-tooltip />
                <el-table-column prop="dqjdfzr" label="当前进度负责人" align="center" show-overflow-tooltip />
              </el-table>
            </el-main>
          </el-container>
        </el-card>
      <template v-if="activeName === 1" #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submitForm(1)">提交</el-button>
            <el-button @click="submitForm(0)">保存草稿</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch, unref } from 'vue'
import { actionPost, loadSelect } from '@/api/common'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'
const props = defineProps({
  isShenQingBianJiHome: {
    type: Boolean,
    required: true
  },
  shenQingBianJiHomeObj: {
    type: Object,
    required: false
  }
})
const emits = defineEmits(['update:isShenQingBianJiHome', 'ReturnData'])
const sqczObj = ref()

// 发起审批 开始
const activeName = ref() // 标签选择
const formRef = ref(null)
// [spid] 审批ID [zt] 状态:0-草稿、1-提交 [spbds] 审批表单 [spbds.bdid] 表单ID [spbds.lx] 表单类型 [spbds.inputVal] 表单值(字符串) [spbds.inputArr] 表单值(数组)
const ruleForm = ref({ spbds: [] })

const clztData = ref([])
const dynamicValidateForm = ref({ domains: [] })

// 发起审批 结束

// 查看数据 开始
const loading = ref(false) // 加载
const tableData = ref() // 内容列表
// 查看数据 结束

// 提交
const submitForm = async (val) => {
  const formEl = unref(formRef)
  if (!formEl) return
  await formEl.validate()
  formEl.validate((valid) => {
    if (valid) {
      ruleForm.value.spid = sqczObj.value.id
      ruleForm.value.zt = val
      dynamicValidateForm.value.domains.forEach((element) => {
        if (element.lx === 99) {
          element.inputVal = element.smwz
        }
        const info = {
          bdid: element.id,
          lx: element.lx,
          inputVal: element.inputVal,
          inputArr: element.inputArr
        }
        ruleForm.value.spbds.push(info)
      })
      const o = {
        url: '/api/v2/bangong/bangongshenpishenqing',
        data: ruleForm.value
      }
      actionPost(o).then((res) => {
        if (res.code === 200) {
          emits('ReturnData')
          handleClose()
          successPrompt(res.message)
        } else {
          warningPrompt(res.message)
        }
      })
    } else {
      return false
    }
  })
}
// 关闭
const handleClose = () => {
  emits('update:isShenQingBianJiHome', false)
}
// 发起审批 列表
const initfqList = () => {
  const info = {
    spid: sqczObj.value.id,
    order: 'id',
    sort: 'asc'
  }
  const o = {
    url: '/api/v2/bangong/bangongshenpishenqing/biaodanlist',
    data: info
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      dynamicValidateForm.value.domains = res.data.shenQingBdzjs === null ? res.data.bdzjs : res.data.shenQingBdzjs
      dynamicValidateForm.value.domains.forEach((element) => {
        element.tableId = element.spbdzjid ? element.spbdzjid : element.id
        // 类型：[1]单行文本 [2]多行文本 [3]数字 [4]下拉框 [5]单选 [6]多选 [7]日期 [8]日期区间 [99]标签
        if (element.lx === 3) {
          element.inputVal = element.listBdz ? element.listBdz[0] : element.mrz
        } else if (element.lx === 5) {
          if (element.mrz && element.xxs && element.xxs.length) {
            element.xxs.forEach((e, i) => {
              if (Number(element.mrz) === i) {
                element.inputVal = e.id
              }
            })
          }
          if (element.listBdz && element.xxs && element.xxs.length) {
            element.inputArr = []
            element.xxs.forEach((e) => {
              element.listBdz.forEach((val) => {
                if (e.xxwb === val) {
                  element.inputVal = e.id
                }
              })
            })
          }
        } else if (element.lx === 6) {
          if (element.mrz && element.xxs && element.xxs.length) {
            element.inputArr = []
            element.xxs.forEach((e, i) => {
              if (Number(element.mrz) === i) {
                element.inputArr.push(e.id)
              }
            })
          }
          if (element.listBdz && element.xxs && element.xxs.length) {
            element.inputArr = []
            element.xxs.forEach((e) => {
              element.listBdz.forEach((val) => {
                if (e.xxwb === val) {
                  element.inputArr.push(e.id)
                }
              })
            })
          }
        } else if (element.lx === 7) {
          // if (element.zdz && element.zxz) {
          //   element.inputVal = time.getTime() <= new Date(ruleForm.value.ksksrq).getTime() - 86400000 || time.getTime() >= new Date(ruleForm.value.cjlrjsrq).getTime()
          // }
          element.inputVal = element.mrz || ''
          
        } else if (element.lx === 8) {
          element.inputArr = element.listBdz ? element.listBdz : element.mrz
        } else {
          element.inputVal = element.listBdz ? element.listBdz[0] : element.mrz
          element.inputArr = []
        }
      })
    } else {
      warningPrompt(res.message)
    }
  })
}
// 查看数据 列表
const initckList = () => {
  const info = {
    spid: sqczObj.value.id,
    order: 'sqsj',
    sort: 'asc'
  }
  const o = {
    url: '/api/v2/bangong/bangongshenpishenqing/biaodanshuju',
    data: info
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      tableData.value = res.data
    } else {
      warningPrompt(res.message)
    }
  })
}
watch(
  () => props.isShenQingBianJiHome,
  () => {
    if (props.isShenQingBianJiHome) {
      sqczObj.value = props.shenQingBianJiHomeObj || {}
      activeName.value = sqczObj.value.type
      loadSelect({ url: '/api/v2/bangong/bangongshenpishenqing/shenpishenqingzhuangtai', data: clztData })
      initfqList()
      initckList()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
:deep(.el-dialog__body) {
  background-color: #f5f7fa;
}

:deep(.el-card) {
  border: 0;
}

.tou_bu {
  width: calc(100% - 30px);
  margin-top: -12px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  :deep(.el-tabs__header) {
    margin: 0;
  }

  :deep(.el-tabs__item) {
    font-size: 16px;
  }

  :deep(.el-tabs__nav-wrap::after) {
    height: 0;
  }

  :deep(.el-divider) {
    margin: 10px 0;
  }
}

.shu_zi_kuang {
  width: 100%;
  display: flex;
  align-items: center;
}
.you_zhui {
  :deep(.el-input-number) {
    width: calc(100% - 100px);
    :deep(.el-input__wrapper) {
      padding-left: 100px;
      padding-right: 100px;
    }
  }
}
.wu_zhui {
  :deep(.el-input-number) {
    width: 100%;
    :deep(.el-input__wrapper) {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
.wu_qian_zhui {
  :deep(.el-input-number) {
    width: calc(100% - 50px);
    :deep(.el-input__wrapper) {
      padding-left: 0;
      padding-right: 100px;
    }
  }
}
.wu_hou_zhui {
  :deep(.el-input-number) {
    width: calc(100% - 50px);
    :deep(.el-input__wrapper) {
      padding-left: 100px;
      padding-right: 0;
    }
  }
}
// 前缀
.qian_zhui {
  width: 50px;
}

// 后缀
.hou_zhui {
  width: 50px;
  text-align: right;
}

.cha_kan_shu_ju {
  .el-main {
    padding: 0;
  }
}
.dui_qi_center {
  text-align: center;
}
.dui_qi_right {
  text-align: right;
}
.dui_qi_justify {
  text-align-last: justify
}
.dui_qi_left {
  text-align: left;
}
// 日期框
.ri_qi_kuang {
  width: 100%;
  border: solid 1px #dcdfe6;
  padding: 1px 11px;
  border-radius: 4px;
  color: #606266;
  display: flex;
  flex-direction: row-reverse;
}
</style>
